import { Columns } from "./columns";
import { Filters } from "./filters";
import { Summary } from "./summary";
import { BulkActions } from "./bulk-actions";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

// FinancePodBills reads this endpoint itself because it answers with a bare array rather than the
// { report, totals } envelope ReportProvider expects.
const FinancePodBillsReportConfig: ReportConfigBase = {
  type: EReportTypes.FinancePodBills,
  endpoint: "bill/pod-bills",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: true,
  intro: {
    description: "Print on Demand Bills",
    url: "https://help.commonsku.com/knowledge/new-billing-reports",
  },
  bulkActions: BulkActions,
};

export default FinancePodBillsReportConfig;
